(function () {
  const initRandomBackground = () => {
    const sections = document.querySelectorAll('.aseave-hero');
    if (!sections.length) return;

    sections.forEach((section) => {
      const displayMode = section.dataset.displayMode;
      const blockCount = parseInt(section.dataset.blockCount, 10);
      const backgrounds = section.querySelectorAll('.aseave-hero__background');

      if (!backgrounds.length || blockCount === 0) return;

      let selectedIndex = 0;

      if (displayMode === 'random') {
        // 完全なランダム選択
        selectedIndex = Math.floor(Math.random() * blockCount);
      } else {
        // 'first' または未指定の場合は最初のブロックを表示
        selectedIndex = 0;
      }

      // 選択されたブロックのみを表示
      backgrounds.forEach((bg, index) => {
        if (index === selectedIndex) {
          bg.style.display = '';
        } else {
          bg.style.display = 'none';
        }
      });
    });
  };

  const initAnimations = () => {
    const sections = document.querySelectorAll('.aseave-hero');
    if (!sections.length) return;

    // ページロード時にアニメーション開始する要素
    const immediateSelectors = [
      '.aseave-hero__title > *',
      '.aseave-hero__logo',
      '.aseave-hero__subscription'
    ];

    // スクロールで表示されたらアニメーション開始する要素
    const scrollSelectors = [
      '.aseave-hero__brand-title',
      '.aseave-hero__brand-text',
      '.aseave-hero__cta-text',
      '.aseave-hero__cta-line',
      '.aseave-hero__cta-arrow'
    ];

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const immediateElements = [];
    const scrollElements = [];

    sections.forEach((section) => {
      section.classList.add('aseave-hero--has-animation');

      // 即座にアニメーション開始する要素
      immediateSelectors.forEach((selector) => {
        section.querySelectorAll(selector).forEach((element) => {
          if (!element.classList.contains('is-animated')) {
            immediateElements.push(element);
          }
        });
      });

      // スクロールでアニメーション開始する要素
      scrollSelectors.forEach((selector) => {
        section.querySelectorAll(selector).forEach((element) => {
          if (!element.classList.contains('is-animated')) {
            scrollElements.push(element);
          }
        });
      });
    });

    // Add Overlay Nav animation (スクロールで表示)
    const overlayNavSections = document.querySelectorAll('.aseave-hero-overlay-nav');
    overlayNavSections.forEach((navSection) => {
      navSection.classList.add('aseave-hero-overlay-nav--has-animation');
      const surface = navSection.querySelector('.aseave-hero-overlay-nav__surface');
      if (surface && !surface.classList.contains('is-animated')) {
        scrollElements.push(surface);
      }
    });

    if (prefersReducedMotion || typeof window.IntersectionObserver === 'undefined') {
      immediateElements.forEach((element) => {
        element.classList.add('is-animated');
      });
      scrollElements.forEach((element) => {
        element.classList.add('is-animated');
      });
      return;
    }

    // 即座にアニメーション開始
    immediateElements.forEach((element) => {
      element.classList.add('is-animated');
    });

    // スクロールでアニメーション開始
    if (scrollElements.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-animated');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -10px 0px'
        }
      );

      scrollElements.forEach((element) => {
        observer.observe(element);
      });
    }
  };

  const initHeaderReveal = () => {
    const headerWrapper = document.querySelector('.header-wrapper--hero-delay');

    if (!headerWrapper) {
      return;
    }

    let heroSection = null;
    const introSelector = headerWrapper.dataset.headerIntroTarget;
    if (introSelector) {
      heroSection = document.querySelector(introSelector);
    }

    if (!heroSection) {
      heroSection = document.querySelector('.aseave-hero');
    }

    if (!heroSection) {
      heroSection = document.querySelector('.aseave-about');
    }

    if (!heroSection) {
      return;
    }

    if (headerWrapper.dataset.heroRevealInitialized === 'true') {
      return;
    }

    headerWrapper.dataset.heroRevealInitialized = 'true';

    const introTransparent = headerWrapper.dataset.headerIntroTransparent === 'true';

    const setBodyTransparentState = (enabled) => {
      if (!introTransparent) {
        return;
      }

      document.body.classList.toggle('has-intro-transparent-header', Boolean(enabled));
    };

    const isHeroVisible = () => {
      const rect = heroSection.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const headerHeight = headerWrapper.offsetHeight || 0;
      return rect.top < viewportHeight && rect.bottom > headerHeight;
    };

    const hideHeader = () => {
      if (introTransparent) {
        headerWrapper.classList.remove('header-wrapper--hero-hidden');
        if (!headerWrapper.classList.contains('header-wrapper--intro-transparent')) {
          headerWrapper.classList.add('header-wrapper--intro-transparent');
        }
        setBodyTransparentState(true);
        return;
      }

      if (!headerWrapper.classList.contains('header-wrapper--hero-hidden')) {
        headerWrapper.classList.add('header-wrapper--hero-hidden');
      }
    };

    const showHeader = () => {
      headerWrapper.classList.remove('header-wrapper--hero-hidden');

      if (introTransparent) {
        requestAnimationFrame(() => {
          headerWrapper.classList.remove('header-wrapper--intro-transparent');
        });
        setBodyTransparentState(false);
      }
    };

    const ensureVisible = () => {
      headerWrapper.classList.remove('header-wrapper--hero-hidden');
      if (introTransparent) {
        if (isHeroVisible()) {
          headerWrapper.classList.add('header-wrapper--intro-transparent');
          setBodyTransparentState(true);
        } else {
          headerWrapper.classList.remove('header-wrapper--intro-transparent');
          setBodyTransparentState(false);
        }
      }
    };

    const updateVisibility = () => {
      if (isHeroVisible()) {
        hideHeader();
      } else {
        showHeader();
      }
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target !== heroSection) {
              return;
            }

            if (entry.isIntersecting) {
              hideHeader();
              setBodyTransparentState(true);
            } else {
              showHeader();
              setBodyTransparentState(false);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      observer.observe(heroSection);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(heroSection)) {
          observer.disconnect();
          ensureVisible();
          setBodyTransparentState(false);
        }
      });
    } else {
      const onScrollFallback = () => {
        updateVisibility();
      };

      window.addEventListener('scroll', onScrollFallback, { passive: true });
      window.addEventListener('resize', onScrollFallback);

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(heroSection)) {
          window.removeEventListener('scroll', onScrollFallback);
          window.removeEventListener('resize', onScrollFallback);
          ensureVisible();
          setBodyTransparentState(false);
        }
      });
    }

    window.setTimeout(() => {
      if (!isHeroVisible()) {
        ensureVisible();
        setBodyTransparentState(false);
      }
    }, 6000);

    updateVisibility();
  };

  const fixUnderscoreSpacing = () => {
    const brandTextElements = document.querySelectorAll('.aseave-hero__brand-text');
    brandTextElements.forEach((element) => {
      let html = element.innerHTML;

      // 全角アンダースコア2つ以上の連続を letter-spacing: 0 で囲む
      html = html.replace(/(＿{2,})/g, '<span style="letter-spacing: 0;">$1</span>');

      // 最後の一文（句点で終わる部分）を改行させない
      html = html.replace(/(([^。、<>]{6,})[。]?)(<\/p>)$/i, '<span style="white-space: nowrap;">$1</span>$3');

      if (element.innerHTML !== html) {
        element.innerHTML = html;
      }
    });
  };

  const init = () => {
    initRandomBackground();
    initAnimations();
    initHeaderReveal();
    fixUnderscoreSpacing();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
